import React, { Component, createRef } from "react";
import FlyerImg from '../../images/FlyerRight.png';
import jsPDF from 'jspdf';
import CardBack from "../Summary/CardBack";
import CardFront from "../Summary/CardFront";

// ─── Placeholder pixel coordinates in the native 2550×3300 FlyerRight.png image ───
// Found by pixel scan: white rectangle starts at y=2535, ends at y=3295 (full width)
const FLYER_W = 2550;
const FLYER_H = 3300;
const PH = { x1: 0, y1: 2535, x2: 2550, y2: 3295 }; // full-width placeholder

class FlyerPage2 extends Component {
    constructor(props) {
        super(props);
        this.containerRef = createRef();
        this.imgRef = createRef();
        this.state = { cardStyle: null };
        this.handleFlyerLoad = this.handleFlyerLoad.bind(this);
        this.downloaddoc = this.downloaddoc.bind(this);
        this.printIndivisual = this.printIndivisual.bind(this);
        this._ro = null;
    }

    componentDidMount() {
        if (this.containerRef.current && typeof ResizeObserver !== 'undefined') {
            this._ro = new ResizeObserver(() => this.handleFlyerLoad());
            this._ro.observe(this.containerRef.current);
        }
    }

    componentWillUnmount() {
        if (this._ro) this._ro.disconnect();
    }

    handleFlyerLoad() {
        const img = this.imgRef.current;
        if (!img) return;
        const sx = img.clientWidth  / FLYER_W;
        const sy = img.clientHeight / FLYER_H;
        this.setState({
            cardStyle: {
                position: 'absolute',
                left:   Math.round(PH.x1 * sx) + 20 + 'px',
                top:    Math.round(PH.y1 * sy) - 20 + 'px',
                width:  Math.round((PH.x2 - PH.x1) * sx) + 'px',
                height: Math.round((PH.y2 - PH.y1) * sy) + 'px',
            }
        });
    }

    waitForImg(imgEl) {
        return new Promise(res => {
            if (!imgEl) { res(); return; }
            if (imgEl.complete && imgEl.naturalWidth > 0) { res(); return; }
            imgEl.onload  = res;
            imgEl.onerror = res;
        });
    }

    async composeCanvas() {
        const container = this.containerRef.current;
        if (!container) return null;

        const flyerImgEl  = this.imgRef.current;
        const frontCanvas = container.querySelector('canvas');
        const backImgEl   = container.querySelector('.flyer-cards-area img') ||
                            container.querySelector('img[alt="Prescription Savings Card — Back"]');

        await this.waitForImg(flyerImgEl);
        await this.waitForImg(backImgEl);

        const scale = 2;
        const composite = document.createElement('canvas');
        composite.width  = FLYER_W * scale;
        composite.height = FLYER_H * scale;
        const ctx = composite.getContext('2d');
        ctx.scale(scale, scale);

        // Helper: draw an image/canvas clipped to a rounded rectangle
        const drawRounded = (src, x, y, w, h, r) => {
            ctx.save();
            ctx.beginPath();
            ctx.moveTo(x + r, y);
            ctx.lineTo(x + w - r, y);
            ctx.quadraticCurveTo(x + w, y, x + w, y + r);
            ctx.lineTo(x + w, y + h - r);
            ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
            ctx.lineTo(x + r, y + h);
            ctx.quadraticCurveTo(x, y + h, x, y + h - r);
            ctx.lineTo(x, y + r);
            ctx.quadraticCurveTo(x, y, x + r, y);
            ctx.closePath();
            ctx.clip();
            ctx.drawImage(src, x, y, w, h);
            ctx.restore();
        };

        if (flyerImgEl) ctx.drawImage(flyerImgEl, 0, 0, FLYER_W, FLYER_H);

        const phW     = PH.x2 - PH.x1;
        const phH     = PH.y2 - PH.y1;
        const S       = FLYER_W / 700;                          // native-px per CSS-px scale
        const gapPx   = Math.round(16 * S);
        // -10px parent width total → -5px per card, on top of existing -10px = -15px per card
        const cardW   = Math.round((phW - gapPx) / 2) - Math.round(15 * S);
        const cardH   = Math.round(cardW * (454 / 772));
        const shiftR  = Math.round(13 * S);                      // 13px CSS right
        const shiftUp = Math.round(18 * S);                      // 18px CSS up from center
        const cardY   = PH.y1 + Math.round((phH - cardH) / 2) - shiftUp;
        const startX  = PH.x1 + shiftR;
        const radius  = Math.round(16 * S);

        if (frontCanvas) {
            drawRounded(frontCanvas, startX, cardY, cardW, cardH, radius);
        }
        if (backImgEl) {
            try { drawRounded(backImgEl, startX + cardW + gapPx, cardY, cardW, cardH, radius); }
            catch (e) { /* skip cross-origin */ }
        }

        return composite;
    }

    async downloaddoc() {
        const composite = await this.composeCanvas();
        if (!composite) return;
        const pdf  = new jsPDF('p', 'mm', 'a4');
        const pdfW = pdf.internal.pageSize.getWidth();
        const pdfH = pdf.internal.pageSize.getHeight();
        const ratio = Math.min((pdfW - 10) / (composite.width / 2), (pdfH - 10) / (composite.height / 2));
        const w = (composite.width  / 2) * ratio;
        const h = (composite.height / 2) * ratio;
        pdf.addImage(composite.toDataURL('image/png'), 'PNG', (pdfW - w) / 2, (pdfH - h) / 2, w, h);
        pdf.save('flyer-2.pdf');
    }

    async printIndivisual() {
        const composite = await this.composeCanvas();
        if (!composite) return;
        const imgSrc = composite.toDataURL('image/png');
        document.body.innerHTML = `<div style="text-align:center;padding:20px;"><img src="${imgSrc}" style="max-width:700px;width:100%;height:auto;display:inline-block;" /></div>`;
        setTimeout(() => { window.print(); window.location.reload(); }, 500);
    }

    render() {
        const { cardStyle } = this.state;
        return (
            <div ref={this.containerRef} style={{ position: 'relative', lineHeight: 0 }}>
                <div className="buttons">
                    <div className="download" onClick={this.downloaddoc}></div>
                    <div className="print"    onClick={this.printIndivisual}></div>
                </div>

                <img
                    ref={this.imgRef}
                    src={FlyerImg}
                    alt="Flyer 2"
                    onLoad={this.handleFlyerLoad}
                    style={{ width: '100%', display: 'block', height: 'auto' }}
                />

                {cardStyle && (
                    <div
                        className="flyer-cards-area"
                        style={{
                            ...cardStyle,
                            display: 'flex',
                            gap: '16px',
                            alignItems: 'center',
                            boxSizing: 'border-box',
                            background: 'transparent',
                        }}
                    >
                        <div style={{ flex: 1, minWidth: 0 }}>
                            <CardFront
                                bin={this.props.bin}
                                pcn={this.props.pcn}
                                classnames={this.props.classnames}
                                PrimaryGn={this.props.groupNumber}
                                mId={this.props.mId}
                            />
                        </div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                            <CardBack
                                bin={this.props.bin}
                                pcn={this.props.pcn}
                                classnames={this.props.classnames}
                                groupData={this.props.groupData}
                                groupNumber={this.props.groupNumber}
                            />
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default FlyerPage2;
